<template>
    <async-wrapper :data="orderRoutes" :loading="async.loading" :error="async.error">
        <template v-if="orderRoutes.length > 0" slot="dataComponent">
            <div v-if="!orderRouteId" class="row">
                <div class="col-xl-12">
                    <h6 class="my-3 text-danger">This order is currently not assigned to a route.</h6>
                </div>
            </div>
            <div v-for="routeRule in orderRoutes" :key="routeRule.id" class="row">
                <div class="col-xl-12">
                    <route-rule :routeRule="routeRule" :isActive="routeRule.id === orderRouteId" :loading="loading" @setRoute="setRoute"></route-rule>
                </div>
            </div>
        </template>
        <template slot="loadingComponent">
            <i class="fa fa-circle-o-notch fa-2x fa-spin mt-5"></i>
        </template>
        <template slot="errorComponent">
            <p>{{ async.error }}</p>
        </template>
    </async-wrapper>
</template>
<script>
import AsyncWrapper from 'Shared/Wrappers/AsyncWrapper'
import { firebaseObjectToArray } from '@/utils'
import swal from 'sweetalert2'
import RouteRule from 'Shared/Cards/RouteRule'
export default {
    components: {
        AsyncWrapper,
        RouteRule
    },
    props: {
        courierId: {
            type: String,
            required: true
        },
        orderRouteId: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            orderId: this.$route.params.id,
            loading: false,
            error: ''
        }
    },
    computed: {
        async() {
            return this.$store.getters['orderMessages/GET_ASYNC']
        },
        orderRoutes() {
            const routes = this.$store.getters['orderRoutes/GET_ROUTES']
            return Object.keys(routes).length > 0 ? firebaseObjectToArray(routes) : false
        }
    },
    created() {
        this.$store.dispatch('orderRoutes/FETCH_ORDER_COURIER_ROUTES', {
            id: this.courierId
        })
    },
    beforeDestroy() {
        this.$store.dispatch('orderRoutes/REMOVE_ORDER_COURIER_ROUTES_REFERENCE', {
            id: this.courierId
        })
    },
    methods: {
        async setRoute(data) {
            const { routeId, shouldEmail } = data
            try {
                await swal({
                    title: `Are you sure you wish to change the order's route?`,
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonClass: 'btn btn-primary btn-fill',
                    cancelButtonClass: 'btn btn-light btn-fill',
                    confirmButtonText: 'Change Route',
                    buttonsStyling: false
                })
                this.loading = routeId
                await this.$store.dispatch('orderRoutes/CHANGE_ROUTE', {
                    orderId: this.orderId,
                    routeId,
                    shouldEmail
                })
                this.$notify({
                    icon: 'nc-icon nc-check-2',
                    message: 'The order route was successfully changed!',
                    type: 'success',
                    horizontalAlign: 'center',
                    verticalAlign: 'bottom'
                })
            } catch (err) {
                if (err.message) {
                    this.$notify({
                        icon: 'nc-icon nc-simple-remove',
                        message: err.message,
                        type: 'danger',
                        horizontalAlign: 'center',
                        verticalAlign: 'bottom',
                        timeout: 0
                    })
                }
            } finally {
                this.loading = false
            }
        }
    }
}
</script>
